import HttpService from '../HttpService';

export default class MajorityService {
  constructor() {
    this._httpService = new HttpService('/servicos/');
  }

  async RequestExclusion(payload, majorityId) {
    return await this._httpService.post(`majority/${majorityId}/requestExclusion`, payload);
  }

  async RequestCoverage(payload, majorityId) {
    return await this._httpService.post(`majority/${majorityId}/requestCoverageExtension`, payload);
  }

  async Reprocess(payload) {
    return await this._httpService.post(`majority/reprocess`, payload);
  }

  async FetchMajorities(params) {
    return await this._httpService.get(`majority?${params}`);
  }

  async FetchProtocols(params) {
    return await this._httpService.get(`majority/protocols?${params}`);
  }

  Export(payload) {
    return this._httpService.post(`majority/export`, payload);
  }
}
